import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 6.752a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v10.5a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3zm1.5 0v.243c0 .52.27 1.005.714 1.278l7.5 4.615a1.5 1.5 0 0 0 1.572 0l7.5-4.615A1.5 1.5 0 0 0 21 6.995v-.243a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5m18 2.842-7.428 4.571a3 3 0 0 1-3.144 0L3 9.595v7.657a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }